export function createTopScroll({ isLoggedIn, modalTopRef }) {
  return function topScroll() {
    if (isLoggedIn) {
      setTimeout(() => {
        if (modalTopRef.current) {
          modalTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 12000);
    } else {
      setTimeout(() => {
        if (modalTopRef.current) {
          modalTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 2000);
    }
  };
}
